@if (!authStore.initialized()) {
  <nexo-loading label="Preparando sessão..." />
} @else {
  <router-outlet />
}
